import { useController } from 'react-hook-form';

import cn from 'app/utils/ClassName';

interface Props {
  name: string;
  label?: string;
  flexDirection?: 'row' | 'col';
  className?: string;
  labelClassName?: string;
  isShowText?: boolean;
  isDisable?: boolean;
  onConfirm?: () => void;
  onChangeCallback?: () => void;
}
export const SwitchField = ({
  name,
  label,
  flexDirection = 'col',
  className,
  labelClassName,
  isShowText = false,
  isDisable = false,
  onConfirm,
  onChangeCallback,
}: Props) => {
  const {
    field: { value, onChange },
    fieldState,
  } = useController({
    name,
    defaultValue: false,
  });

  function getText(currentValue: boolean, isShow: boolean) {
    if (!isShow) { return null; }
    return currentValue ? <div className="mr-[16px]">是</div> : <div className="ml-[16px]">否</div>;
  }

  return (
    <div className={cn('flex flex-col gap-[4px]', className)}>
      <button
        type="button"
        className={cn(
          'flex w-fit gap-[12px]',
          flexDirection === 'row' ? 'flex-row  items-center' : 'flex-col items-start',
          isDisable && 'cursor-not-allowed',
        )}
        disabled={isDisable}
        onClick={() => {
          if (onConfirm && !value) {
            onConfirm();
          } else {
            onChange(!value);
            onChangeCallback?.();
          }
        }}
      >
        {label ? (
          <div
            className={cn(
              'text-[14px] font-semibold leading-[16.94px] text-text-primary',
              labelClassName,
            )}
          >
            {label}
          </div>
        ) : null}
        <div
          className={cn(
            'relative h-[26px] w-[46px] rounded-[20px]',
            value ? 'bg-orange-300' : 'bg-text-light',
            isShowText ? 'flex items-center justify-center pt-px text-xs text-white' : undefined,
          )}
        >
          {getText(value, isShowText)}
          <div
            className={cn(
              'absolute right-[3px] top-[3px] size-[20px] rounded-full bg-white transition duration-200',
              value ? '' : 'translate-x-[-20px]',
            )}
          />
        </div>
      </button>
      {fieldState.error?.message ? (
        <p className="text-left text-[12px] font-normal leading-[14.32px] tracking-[0.01em] text-brand-attention">
          {fieldState.error.message}
        </p>
      ) : <div className="h-[14.32px]" />}
    </div>
  );
};
